import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, OnInit,} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {NbButtonModule, NbSpinnerModule} from '@nebular/theme';
import {FormlyModule} from '@ngx-formly/core';
import {BaseComponent, ListFilterService} from 'compob2b-libs';
import {debounceTime, take, takeUntil, tap} from 'rxjs/operators';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormlyModule, NbButtonModule, NbSpinnerModule]
})
export class FilterComponent extends BaseComponent implements OnInit {
  @Input() filter: ListFilterService;

  formFilter = new UntypedFormGroup({});
  private httpSubscription: Subscription;
  private previousCatalogId: string | null = null;

  constructor(protected readonly route: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.route.queryParamMap.pipe(
      tap(_ => this.loading = true),
      debounceTime(100),
      tap(params => this.updateFilters(params)),
      takeUntil(this.unsubscribe)
    ).subscribe();
  }

  updateFilters(params: ParamMap) {
    const currentCatalogId = params.get('catalog_id');

    if (this.previousCatalogId !== null && this.previousCatalogId !== currentCatalogId) {
      this.filter.reset();
      this.formFilter.reset();
      this.cdr.detectChanges();
    }

    this.previousCatalogId = currentCatalogId;

    this.httpSubscription?.unsubscribe();
    this.httpSubscription = this.filter
      .getProductFilter('/product', Number(params.get('catalog_id')), this.paramsToHttp(params))
      .pipe(take(1))
      .subscribe(() => {
        this.loading = false;
        this.httpSubscription = null;
        this.cdr.detectChanges();
      });
  }

  get isCatalog(): boolean {
    return this.router.url?.startsWith('/catalog');
  }

  change(): void {
    // Трогать url можно только в каталоге
    if (this.isCatalog) {
      this.submit();
    }
  }

  submit(): void {
    if (this.formFilter.valid) {
      this.router.navigate(['/catalog'], {
        queryParams: this.filter.convertModelFeatures(),
        queryParamsHandling: null
      });
    }
  }

  reset(): void {
    this.filter.reset();
    this.formFilter.reset();
    this.cdr.detectChanges();

    this.router.navigate(['/catalog'], {
      queryParams: {},
      queryParamsHandling: null
    });
  }

}
